import React, { useState } from "react";
import { Container, Form, Button } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";

export default function VerifyOtp() {
  const navigate = useNavigate();
  const location = useLocation();

  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");

  const handleVerify = () => {
    if (!otp) {
      setOtpError("Enter OTP");
      return;
    }

    if (otp.length !== 6) {
      setOtpError("OTP must be 6 digits");
      return;
    }

    const defaultUser = {
      name: "Arjun Kumar",
      role: "user",
    };

    localStorage.setItem("user", JSON.stringify(defaultUser));

    navigate("/user/home");
  };

  return (
    <Container style={{ maxWidth: "400px", marginTop: "120px" }}>
      <h3 className="mb-4 text-center">Enter OTP</h3>

      <Form.Group>
        <Form.Control
          type="text"
          placeholder="Enter 6 digit OTP"
          value={otp}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, "");
            if (value.length <= 6) setOtp(value);
          }}
        />
      </Form.Group>

      {otpError && <small style={{ color: "red" }}>{otpError}</small>}

      <Button className="mt-3 w-100" onClick={handleVerify}>
        Verify OTP
      </Button>
    </Container>
  );
}
